import { css } from '@emotion/css';
import { Theme } from '@mui/material';

export const useTopLevelMenuStyles = (theme: Theme) => {
  const isDarkTheme = theme.palette.mode === 'dark';

  return {
    root: css({
      zIndex: theme.zIndex.appBar + 2,
      minHeight: 34,
      display: 'flex',
      justifyContent: 'center',
      alignContent: 'center',
      paddingTop: theme.spacing(0.25),
      paddingBottom: theme.spacing(0.25),
      borderRadius: '3px',

      [theme.breakpoints.down('lg')]: {
        marginLeft: theme.spacing(0.75),
        paddingLeft: theme.spacing(0.5),
        paddingRight: theme.spacing(0.5),
      },
      [theme.breakpoints.up('lg')]: {
        marginLeft: theme.spacing(1),
        paddingLeft: theme.spacing(0.75),
        paddingRight: theme.spacing(0.75),
      },

      '&:hover': {
        backgroundColor: theme.palette.primary.light,
        cursor: 'pointer',
      },
    }),
    iconButton: css({
      '&.MuiButtonBase-root.MuiIconButton-root:hover:after': {
        display: 'none',
        content: 'none',
        border: 'none',
        background: 'none',
        width: 0,
        height: 0,
      },
    }),
    link: css({
      '&.MuiLink-root': {
        cursor: 'pointer',
        textDecoration: 'none',
        height: '100%',
        fontSize: theme.typography.fontSize,

        '&:hover': {
          backgroundColor: theme.palette.primary.light,
          cursor: 'pointer',
          textDecoration: 'none',

          '& .MuiTypography-root': {
            color: theme.palette.secondary.main,
          },
        },
      },
    }),
    chevron: css({
      marginLeft: theme.spacing(0.5),
    }),
    text: css({
      whiteSpace: 'nowrap',

      '&.MuiTypography-subtitle1': {
        color: isDarkTheme ? theme.palette.info.contrastText : theme.palette.text.primary,
        fontWeight: theme.typography.fontWeightBold,
        fontSize: 16,

        '&:visited': {
          color: theme.palette.text.primary,
        },
      },
    }),
    menuListPaper: css({
      '&.MuiPaper-root.MuiPopover-paper': {
        maxHeight: 'calc(100% - 100px)',
        zIndex: theme.zIndex.modal + 15,
        marginTop: -40,
      },
    }),
    menuModal: css({
      '&.MuiModal-root': {
        top: 40,
        zIndex: theme.zIndex.modal + 10,
      },
    }),
  };
};
